/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  CLIENT_EDR_CONFIGURATION_ASSESSMENT,
  CLIENT_EDR_ENDPOINTS,
  CLIENT_EDR_FILE_INTEGRITY_MONITORING,
  CLIENT_EDR_MALWARE_DETECTION,
  CLIENT_EDR_VULNERABILITIES_DETECTION,
} from 'src/constants/constants';
import { SECURITY_EDR_SEGMENT, SECURITY_NAV_ROUTE_ITEMS, SECURITY_SOC_SEGMENT } from './securityNav';

/** Base path segment for all Security child routes (no leading/trailing slash). */
export const SECURITY_ROUTE_PATH_PREFIX = '/mindtime/security/';

/**
 * Slugs for Security pages with dedicated implementations in routes.tsx.
 * Add new entries here when a page is built; keep placeholder nav in sync via NAV_IDS_WITH_PAGES.
 */
export const SECURITY_PAGE_ROUTES = {
  securityOperationsCenter: SECURITY_SOC_SEGMENT,
  resellerDashboard: `${SECURITY_EDR_SEGMENT}/reseller-dashboard`,
  subOrgDashboard: `${SECURITY_EDR_SEGMENT}/sub-org-dashboard`,
  clients: `${SECURITY_EDR_SEGMENT}/clients`,
  configurationAssessment: `${SECURITY_EDR_SEGMENT}/configuration-assessment`,
  complianceDetail: `${SECURITY_EDR_SEGMENT}/configuration-assessment/:recordId`,
  deployAgent: `${SECURITY_EDR_SEGMENT}/endpoints/deploy-agent`,
  fileIntegrityMonitoring: `${SECURITY_EDR_SEGMENT}/file-integrity-monitoring`,
  fileIntegrityDetail: `${SECURITY_EDR_SEGMENT}/file-integrity-monitoring/:recordId`,
  threatHunting: `${SECURITY_EDR_SEGMENT}/threat-hunting`,
  malwareDetection: `${SECURITY_EDR_SEGMENT}/malware-detection`,
  malwareDetail: `${SECURITY_EDR_SEGMENT}/malware-detection/:recordId`,
  automatedResponse: `${SECURITY_EDR_SEGMENT}/automated-response`,
  vulnerabilityDetection: `${SECURITY_EDR_SEGMENT}/vulnerability-detection`,
  vulnerabilityDetail: `${SECURITY_EDR_SEGMENT}/vulnerability-detection/:recordId`,
  mitreAttck: `${SECURITY_EDR_SEGMENT}/mitre-attck`,
  endpoints: `${SECURITY_EDR_SEGMENT}/endpoints`,
  endpointDetails: `${SECURITY_EDR_SEGMENT}/endpoints/:systemWazuhAgentId`,
} as const;

export const SECURITY_EDR_SUB_ROUTE_PERMISSIONS = {
  deployAgent: CLIENT_EDR_ENDPOINTS,
  endpointDetails: CLIENT_EDR_ENDPOINTS,
  complianceDetail: CLIENT_EDR_CONFIGURATION_ASSESSMENT,
  fileIntegrityDetail: CLIENT_EDR_FILE_INTEGRITY_MONITORING,
  malwareDetail: CLIENT_EDR_MALWARE_DETECTION,
  vulnerabilityDetail: CLIENT_EDR_VULNERABILITIES_DETECTION,
} as const;

/** Nav item ids that map to a real page (excluded from auto-generated placeholder routes). */
const NAV_IDS_WITH_PAGES: readonly string[] = [
  'security-operations-center',
  'reseller-dashboard',
  'sub-org-dashboard',
  'clients',
  'endpoints',
  'configuration-assessment',
  'file-integrity-monitoring',
  'threat-hunting',
  'malware-detection',
  'automated-response',
  'vulnerability-detection',
  'mitre-attck',
];

/** Sidebar nav items that still use SectionPlaceholder until implemented. */
export const getSecurityPlaceholderNavItems = () =>
  SECURITY_NAV_ROUTE_ITEMS.filter((item) => !NAV_IDS_WITH_PAGES.includes(item.id));

export const toSecurityChildPath = (fullPath: string): string =>
  fullPath.replace(SECURITY_ROUTE_PATH_PREFIX, '');
